import styled from 'styled-components'
import { themeFontFamily, themeFontWeight, themeColor } from 'LibNeo'

export const Description = styled.span`
	font-size: 14px;
	font-family: ${themeFontFamily('SBSansText')};
	font-weight: ${themeFontWeight('SBSansText', 'regular')};
	color: ${themeColor('gray', 8)};
	line-height: 20px;
`

export const ChangeWrapper = styled.span`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	border-top: 1px solid ${themeColor('gray', 3)};
	border-bottom: 1px solid ${themeColor('gray', 3)};
	margin: 24px 0;
	padding: 24px 0;
`

export const ModalButtonWrapper = styled.div`
	display: flex;
	gap: 16px;
`
export const SuccessModalWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-direction: column;
	gap: 16px;
	font-size: 14px;
	font-family: ${themeFontFamily('SBSansText')};
	font-weight: ${themeFontWeight('SBSansText', 'regular')};
	color: ${themeColor('gray', 8)};
`

export const SuccessModalDescription = styled.div`
	text-align: center;
`
export const ModalContent = styled.div`
	display: flex;
	align-items: center;
	border-radius: 8px;
	padding: 12px;
	justify-content: center;
	background-color: ${themeColor('gray', 1)};
`

export const ModalTimer = styled.div`
	display: flex;
	gap: 16px;
	align-items: center;
`
